import { axiosInstance } from '../Axios';
const { createSlice } = require('@reduxjs/toolkit');

const EtravReducer = createSlice({
	name: 'Etrav',
	initialState: {
		success: false,
		error: null,
		load: false,
		etravresult: null,
	},
	reducers: {
		searchEtravRequest(state, action) {
			state.load = true;
		},
		searchEtravSuccess(state, action) {
			state.load = false;
			state.etravresult = action.payload;
			state.error = null;
		},
		searchEtravFail(state, action) {
			state.load = false;
			state.error = action.payload;
		},
	},
});

const { actions } = EtravReducer;
const config = {
	headers: {
		'Content-Type': 'application/json',
		'Client-Service': 'srk-client',
		'Auth-Key': 'srkapi',
		'Api-Key': 'NjO7hqe3PG9musafi==',
	},
};

export const { searchEtravRequest, searchEtravSuccess, searchEtravFail } =
	actions;

export const SearchEtravDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(searchEtravSuccess(null));
		dispatch(searchEtravRequest());
		const etrav = await axiosInstance.post(
			'FlyEtrav/flightsearch',
			bodyData,
			config
		);

		dispatch(searchEtravSuccess(etrav.data));
		console.log('etrav', etrav.data);
	} catch (error) {
		dispatch(
			searchEtravFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};

export default EtravReducer;
